var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "avatar_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 100c27.614 0 50-22.386 50-50S78.114 0 50.5 0 .5 22.386.5 50s22.386 50 50 50z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#avatar_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5 100c27.614 0 50-22.386 50-50S78.114 0 50.5 0 .5 22.386.5 50s22.386 50 50 50z",
    fill: "#F1F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 60.526c11.513 0 21.053-9.375 21.053-21.052 0-11.513-9.54-21.053-21.053-21.053-11.678 0-21.053 9.54-21.053 21.053A20.988 20.988 0 0050.5 60.526zm8.224 7.895H42.112c-15.79 0-28.454 12.83-28.454 28.619a5.546 5.546 0 005.592 5.592h62.336c3.125 0 5.756-2.467 5.756-5.592 0-15.79-12.829-28.619-28.618-28.619z",
    fill: "#ADB5BD"
  }))));
}
export default SvgAvatar;